import { render, staticRenderFns } from "./Costumes.vue?vue&type=template&id=1c4dcbe2&scoped=true&"
import script from "./Costumes.vue?vue&type=script&lang=js&"
export * from "./Costumes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4dcbe2",
  null
  
)

export default component.exports